import React from "react";

export default function ProjectCard({ project, onClick }) {
  return (
    <button
      type="button"
      className="group relative w-full h-[250px] sm:h-[280px] lg:h-[320px] cursor-pointer text-left block rounded-2xl"
      style={{ perspective: "1000px" }}
      onClick={onClick}
    >
      <div
        className="flip-inner relative w-full h-full transition-transform duration-700 ease-in-out"
        style={{ transformStyle: "preserve-3d" }}
      >
        {/* Front side: Image and Title */}
        <div
          className="glass-card rounded-2xl border-biolum-green/30 bg-neutral-900/80 absolute inset-0 flex flex-col w-full h-full overflow-hidden border"
          style={{ backfaceVisibility: "hidden" }}
        >
          <div className="h-3/4 sm:p-3 bg-black/40 flex items-center justify-center w-full p-2">
            {/* The uniform box that glows */}
            <div className="w-full h-full rounded-2xl shadow-[0_0_20px_rgba(0,255,255,0.4)] flex items-center justify-center">
              <img
                src={project.image}
                alt={project.title}
                className="rounded-2xl object-contain max-w-full max-h-full p-1"
              />
            </div>
          </div>
          <div className="h-1/4 sm:p-3 bg-neutral-800/50 border-biolum-green/20 flex items-center justify-center w-full p-2 border-t">
            <h3 className="sm:text-lg text-base font-bold text-center text-white">
              {project.title}
            </h3>
          </div>
        </div>

        {/* Back side: Description and Technologies */}
        <div
          className="glass-card absolute inset-0 w-full h-full rounded-2xl border border-biolum-green/50 flex flex-col p-3 sm:p-4 overflow-hidden bg-neutral-900 shadow-[0_0_30px_rgba(0,255,255,0.2)]"
          style={{
            backfaceVisibility: "hidden",
            transform: "rotateY(180deg)",
          }}
        >
          <h3 className="sm:text-lg sm:mb-3 text-biolum-green mb-2 text-base font-bold">
            {project.title}
          </h3>
          <div className="custom-scrollbar flex-grow pr-2 overflow-y-auto">
            <p className="text-neutral-300 sm:text-sm mb-4 text-xs leading-relaxed">
              {project.description}
            </p>
          </div>
          <div className="flex flex-wrap gap-2 mt-4">
            {project.technologies.slice(0, 4).map((tech, i) => (
              <span
                key={i}
                className="text-xs bg-black px-2 py-1 rounded text-biolum-blue border border-biolum-blue/30 shadow-[0_0_5px_rgba(0,255,255,0.2)]"
              >
                {tech}
              </span>
            ))}
            {project.technologies.length > 4 && (
              <span className="text-xs bg-black px-2 py-1 rounded text-biolum-blue border border-biolum-blue/30 shadow-[0_0_5px_rgba(0,255,255,0.2)]">
                +{project.technologies.length - 4} more
              </span>
            )}
          </div>
        </div>
      </div>

      {/* Invisible group-hover trigger for the rotation of the inner div */}
      {/* We apply the hover pseudo-class natively in standard Tailwind CSS on the parent, but since we use incline style for preserve-3d, we can just use group-hover class on the inner child */}
      <style jsx="true">{`
        @media (min-width: 768px) {
          .group:hover > .flip-inner {
            transform: rotateY(180deg);
          }
        }
      `}</style>
    </button>
  );
}
